import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { CircularProgress, Fade } from '@material-ui/core';
import { withTheme } from '@material-ui/core/styles';
import moment from 'moment';
import Cookies from 'universal-cookie';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
    validateOTP,
    emailValidate,
    passwordMatchValidate
} from '../../utils/validators/validateForm';
import {
    NotificationManager,
    NotificationContainer
} from 'react-notifications';
import { Redirect } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaderButton: false,
            email: '',
            emailError: '',
            dashboardRedirect: false,
            showContent: 1,
            password: '',
            passwordError: '',
            confirmPassword: '',
            confirmPasswordError: '',
            forgotToken: '',
            otp: '',
            otpError: '',
            timer: 60
        };
    }

    handleClose = () => {
        this.props.close();
    };
    renderButton = () => {
        if (this.state.loaderButton) {
            return <CircularProgress />;
        } else {
            return (
                <Button
                    variant="contained"
                    style={{
                        backgroundColor: this.props.theme.palette.primary.main,
                        color: '#ffffff',
                        fontSize: '16px'
                    }}
                    size="large"
                    onClick={() => this.forgotPasswordActionCall()}
                >
                    {this.state.showContent == 1 &&
                        this.props.intl.formatMessage({ id: 'Next' })}
                    {this.state.showContent == 2 &&
                        this.props.intl.formatMessage({ id: 'Next' })}
                    {this.state.showContent == 3 &&
                        this.props.intl.formatMessage({ id: 'Done' })}
                </Button>
            );
        }
    };

    forgotPasswordActionCall = () => {
        if (this.state.showContent == 1) {
            if (emailValidate(this.state.email, this.handleError)) {
                this.setState({ loaderButton: true });
                this.props.forgotPasswordAction(
                    {
                        email: this.state.email
                    },
                    this.onForgotEmailDone
                );
            }
        } else if (this.state.showContent == 2) {
            if (validateOTP(this.state.otp, this.handleError)) {
                this.setState({ loaderButton: true });
                this.props.checkForgotOtpAction(
                    {
                        email: this.state.email,
                        otp: this.state.otp
                    },
                    this.onOtpDone
                );
            }
        } else if (this.state.showContent == 3) {
            if (
                passwordMatchValidate(
                    this.state.password,
                    this.state.confirmPassword,
                    this.handleError
                )
            ) {
                this.setState({ loaderButton: true });
                this.props.resetPasswordAction(
                    {
                        email: this.state.email,
                        token: this.state.forgotToken,
                        password: this.state.password
                    },
                    this.onResetPassword
                );
            }
        }
    };

    resendOtp = () => {
        this.setState({ timer: 60 });
        this.interval = setInterval(() => {
            if (this.state.timer === 0) {
                return clearInterval(this.interval);
            }
            this.setState({ timer: this.state.timer - 1 });
        }, 1000);
        this.props.forgotPasswordAction(
            {
                email: this.state.email
            },
            this.onResendDone
        );
    };
    handleError = params => {
        this.setState(params);
    };

    onConfirmPasswordChange = event => {
        this.setState({
            confirmPassword: event.target.value,
            confirmPasswordError: ''
        });
    };
    onChangeEmail = event => {
        this.setState({
            email: event.target.value,
            emailError: ''
        });
    };
    onChangeOtp = event => {
        this.setState({
            otp: event.target.value,
            otpError: ''
        });
    };
    onChangePassword = event => {
        this.setState({
            password: event.target.value,
            passwordError: ''
        });
    };

    onForgotEmailDone = (success, data) => {
        if (success) {
            this.setState(function(previousState) {
                return {
                    showContent: previousState.showContent + 1,
                    loaderButton: false
                };
            });
            this.interval = setInterval(() => {
                if (this.state.timer === 0) {
                    return clearInterval(this.interval);
                }
                this.setState({ timer: this.state.timer - 1 });
            }, 1000);
        } else {
            this.setState({
                loaderButton: false,
                emailError: data
            });
        }
    };

    onOtpDone = (success, data) => {
        if (success) {
            this.setState(function(previousState) {
                return {
                    showContent: previousState.showContent + 1,
                    loaderButton: false,
                    forgotToken: data.token
                };
            });
        } else {
            this.setState({
                loaderButton: false,
                otpError: data
            });
        }
    };
    onResetPassword = (success, data) => {
        if (success) {
            this.setState({
                loaderButton: false
            });
            this.props.close();
            NotificationManager.success(
                <FormattedMessage
                    id="passwordResetSuccess"
                    defaultMessage="Password Reset Successfully, you can login now!"
                />,
                'Success'
            );
        } else {
            this.setState({
                loaderButton: false,
                passwordError: data
            });
            NotificationManager.error('Error', data.message);
        }
    };
    onResendDone = (success, data) => {
        if (success) {
            this.setState(function(previousState) {
                return {
                    showContent: 2,
                    loaderButton: false
                };
            });
        }
    };
    render() {
        const {
            emailError,
            showContent,
            otpError,
            passwordError,
            confirmPasswordError,
            loaderButton
        } = this.state;
        const { formatMessage } = this.props.intl;
        if (this.state.dashboardRedirect) {
            return (
                <Redirect
                    to={{
                        pathname: `/user/dashboard`
                    }}
                />
            );
        }
        return (
            <div>
                <Dialog
                    TransitionComponent={Fade}
                    disableBackdropClick={false}
                    className="service-modal forgot-modal"
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <form
                        className="dialog-form dialog-form-new"
                        autocomplete="off"
                    >
                        <div
                            className="modal-header dir-pop-head"
                            style={{
                                backgroundColor: this.props.theme.palette
                                    .primary.main
                            }}
                        >
                            {showContent == 1 && (
                                <h3 className="dialog-heading">
                                    <FormattedMessage
                                        id="forgotPassword"
                                        defaultMessage="Forgot Password?"
                                    />
                                </h3>
                            )}
                            {showContent == 2 && (
                                <h3 className="dialog-heading">
                                    <FormattedMessage
                                        id="verifyOtp"
                                        defaultMessage="Verify OTP"
                                    />
                                </h3>
                            )}
                            {showContent == 3 && (
                                <h3 className="dialog-heading">
                                    <FormattedMessage
                                        id="resetPassword"
                                        defaultMessage="Reset Password"
                                    />
                                </h3>
                            )}
                        </div>
                        <div className="modal-body dir-pop-body">
                            <DialogContent className="service-from-body">
                                {showContent == 1 && (
                                    <TextField
                                        error={emailError ? true : false}
                                        helperText={emailError}
                                        placeholder={formatMessage({
                                            id: 'enterEmail'
                                        })}
                                        className="login-form-textfield"
                                        id="email"
                                        fullWidth={true}
                                        name="email"
                                        type="text"
                                        value={this.state.email}
                                        onChange={this.onChangeEmail}
                                        disabled={loaderButton}
                                    />
                                )}
                                {showContent == 2 && (
                                    <div>
                                        <TextField
                                            error={otpError ? true : false}
                                            helperText={otpError}
                                            label={formatMessage({
                                                id: 'enterOTP'
                                            })}
                                            id="otp"
                                            fullWidth={true}
                                            name="otp"
                                            type="text"
                                            value={this.state.otp}
                                            onChange={this.onChangeOtp}
                                            disabled={loaderButton}
                                        />
                                        <div>
                                            {this.state.timer == 0 && (
                                                <a
                                                    style={{
                                                        cursor: 'pointer',
                                                        color: this.props.theme
                                                            .palette.primary
                                                            .main
                                                    }}
                                                    onClick={this.resendOtp}
                                                    disabled={
                                                        this.state.timer > 0
                                                    }
                                                >
                                                    <FormattedMessage
                                                        id="resendOtp"
                                                        defaultMessage="Resend OTP"
                                                    />{' '}
                                                </a>
                                            )}
                                        </div>
                                        {this.state.timer > 0 && (
                                            <div>
                                                {' '}
                                                <FormattedMessage
                                                    id="youCanResendOtp"
                                                    defaultMessage="You can Resend OTP in"
                                                />{' '}
                                                <b>
                                                    {this.state.timer !== 0
                                                        ? this.state.timer
                                                        : ''}
                                                </b>{' '}
                                                <FormattedMessage
                                                    id="secs"
                                                    defaultMessage="secs"
                                                />
                                            </div>
                                        )}
                                    </div>
                                )}

                                {showContent == 3 && (
                                    <div>
                                        <TextField
                                            error={passwordError ? true : false}
                                            helperText={passwordError}
                                            label={formatMessage({
                                                id: 'enterNewPassword'
                                            })}
                                            id="password"
                                            fullWidth={true}
                                            name="password"
                                            type="password"
                                            value={this.state.password}
                                            onChange={this.onChangePassword}
                                            disabled={loaderButton}
                                            margin="normal"
                                        />
                                        <TextField
                                            error={
                                                confirmPasswordError
                                                    ? true
                                                    : false
                                            }
                                            helperText={confirmPasswordError}
                                            label={formatMessage({
                                                id: 'confirmPassword'
                                            })}
                                            id="confirmPassword"
                                            fullWidth={true}
                                            name="confirmPassword"
                                            type="password"
                                            value={this.state.confirmPassword}
                                            onChange={
                                                this.onConfirmPasswordChange
                                            }
                                            margin="normal"
                                            disabled={loaderButton}
                                        />
                                    </div>
                                )}
                            </DialogContent>

                            <DialogActions>
                                <div className="col-md-12 log-btn">
                                    {this.renderButton()}
                                </div>
                            </DialogActions>
                        </div>
                    </form>
                </Dialog>
            </div>
        );
    }
}

const composedHOC = compose(
    withTheme(),

    connect(null, actions)
);
export default composedHOC(injectIntl(ForgotPassword));



// WEBPACK FOOTER //
// ./src/views/LoginPage/ForgotPassword.jsx